import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-system",
  "use": "icon-system-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-system\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.8 6.2833H12.4V5.0833C12.4 4.4173 11.866 3.8833 11.2 3.8833H8.8C8.134 3.8833 7.6 4.4173 7.6 5.0833V6.2833H5.2C4.534 6.2833 4.006 6.8173 4.006 7.4833L4 14.0833C4 14.7493 4.534 15.2833 5.2 15.2833H14.8C15.466 15.2833 16 14.7493 16 14.0833V7.4833C16 6.8173 15.466 6.2833 14.8 6.2833ZM11.2001 6.28331H8.80007V5.08331H11.2001V6.28331Z\" fill=\"#93969B\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol